import { render } from "./dlt-4.vue?vue&type=template&id=79767712&scoped=true"
import script from "./dlt-4.vue?vue&type=script&lang=js"
export * from "./dlt-4.vue?vue&type=script&lang=js"

import "./dlt-4.vue?vue&type=style&index=0&id=79767712&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79767712"]])

export default __exports__